<template>
  <div class="personalCenter">
    <div class="peak">
      <img src="@/assets/images/top.png" alt="" />
      <h4 class="title">个人中心</h4>
    </div>
    <div class="background" :class="{ active: selectBg }">
      <img
        :src="pageConfig.personalCenter.backgroundSrc"
        @click="selectModule('background')"
      />
      <div class="info">
        <div class="avarBox">
          <img class="avar" src="@/assets/images/avar.jpg" alt="" />
        </div>
        <span class="name">小云儿</span>
      </div>
      <!-- 控制条 -->
      <div class="controlBarWrap" v-show="bgControlState">
        <ul class="controlList">
          <li class="control" style="color: #ccc">
            <i class="iconfont">&#xe68f;</i>
          </li>
          <li class="control" style="color: #ccc">
            <i class="iconfont">&#xe691;</i>
          </li>
          <li class="control" style="color: #ccc">  
            <i class="iconfont">&#xe690;</i>
          </li>
          <li class="control" style="color: #ccc">
            <i class="iconfont">&#xe692;</i>
          </li>
        </ul>
      </div>
    </div>
    <!-- 等级积分模块 -->
    <ul class="scoreSet mrb10">
      <li class="scoreItem">
        <p>二星会员</p>
        <p>会员等级</p>
      </li>
      <li class="scoreItem">
        <p>69585</p>
        <p>现有积分</p>
      </li>
      <li class="scoreItem">
        <p>3</p>
        <p>参与互动</p>
      </li>
      <li class="scoreItem">
        <p>8</p>
        <p>已兑奖品</p>
      </li>
    </ul>

    <!-- 列表 -->
    <transition-group name="flip-list" tag="ul" ref="list" class="list">
      <template v-for="data in pageConfig.personalCenter.pageComponents">
        <!-- 明细列表  -->
        <li
          v-if="data.id == 10"
          :key="data.id + 'detailed'"
          :data-id="data.id"
          :class="{ active: data.select }"
        >
          <div
            class="detailedList"
            :class="{ active: data.select, mrb10: !data.hideGaps }"
            @click="selectModule(data)"
          >
            <template
              v-for="(item, index) in pageConfig.personalCenter.detailedList"
            >
              <div class="detailedItem" :key="'detailed' + index">
                <div class="detail">
                  <img class="icon" :src="item.imageUrl" />
                  <span class="name">{{ item.name }}</span>
                </div>
                <i class="el-icon-arrow-right"></i>
              </div>
            </template>
          </div>
          <!-- 控制条 -->
          <div class="controlBarWrap" v-show="data.select">
            <ul class="controlList">
              <li class="control" @click="handleControl('topping', data)">
                <i class="iconfont">&#xe68f;</i>
              </li>
              <li class="control" @click="handleControl('moveUp', data)">
                <i class="iconfont">&#xe691;</i>
              </li>
              <li class="control" @click="handleControl('moveDown', data)">
                <i class="iconfont">&#xe690;</i>
              </li>
              <li class="control" @click="handleControl('delete', data)">
                <i class="iconfont">&#xe692;</i>
              </li>
            </ul>
          </div>
        </li>
      </template>
    </transition-group>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Sortable from "sortablejs";

export default {
  computed: {
    ...mapState(["pageConfig"]),
  },
  data() {
    return {
      selectBg: false,
      bgControlState: false,
      domList: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapMutations([
      "componentListChange",
      "addComponent",
      "switchConfigState",
      "toppingComponent",
      "upAndDown",
      "delComponent",
    ]),
    init() {
      let self = this;
      let options = {
        animation: 500,
        dataIdAttr: "data-id",
        filter: ".filter",
        sort: false,
        group: { name: "list", pull: false, put: true },
        onAdd(evt) {
          const arr = sortList.toArray();
          self.componentListChange(+evt.oldIndex);
          self.addComponent(arr);
          self.domList.push({
            id: evt.clone.dataset.id,
            dom: evt.clone,
          });
          evt.clone.className = "wrap";
          evt.item.remove();
        },
        onEnd: function(evt) {},
      };
      var sortList = Sortable.create(this.$refs.list.$el, options);
    },
    selectModule(data) {
      if (data === "background") {
        if (this.selectBg) return;
        this.selectBg = true;
        this.bgControlState = true;
        this.pageConfig.personalCenter.pageComponents.forEach(
          (item) => (item.select = false)
        );
        this.switchConfigState(0);
      } else {
        this.selectBg = false;
        this.bgControlState = false;
        if (data.select) return;
        this.pageConfig.personalCenter.pageComponents.forEach(
          (item) => (item.select = false)
        );
        data.select = true;
        this.switchConfigState(data.id);
      }
    },
    handleControl(type, data) {
      switch (type) {
        case "topping":
          this.toppingComponent(data.id);
          break;
        case "moveUp":
          this.upAndDown({ id: data.id, type: "moveUp" });
          break;
        case "moveDown":
          this.upAndDown({ id: data.id, type: "moveDown" });
          break;
        case "delete":
          this.delComponent(data.id);
          const obj = this.domList.find((item) => item.id == data.id);
          this.domList = this.domList.filter((item) => item.id != data.id);
          // 将左侧组件恢复可拖拽状态
          if (obj) obj.dom.className = "wrap draw";
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.personalCenter {
  flex: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  .peak {
    position: relative;
    width: 100%;
    img {
      width: 100%;
    }
    .title {
      position: absolute;
      left: 50%;
      top: 60%;
      transform: translate(-50%);
      margin: 0;
      text-align: center;
      font-size: 20px;
      font-weight: 600;
      color: #333;
    }
  }
  .background {
    position: relative;
    box-sizing: border-box;
    img {
      width: 100%;
      height: 230px;
    }
    .info {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      position: absolute;
      left: 50%;
      top: 20%;
      transform: translateX(-50%);
      border-radius: 50%;
      .avar {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        border: 3px solid #fff;
      }
      .name {
        display: block;
        margin-top: 10px;
        color: #fff;
      }
    }
    &.active {
      border: 2px dashed #4878ff;
    }
  }
  .scoreSet {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    margin: 0 18px 10px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.06);
    background-color: #fff;
    border-radius: 6px;
    transform: translateY(-50%);
    .scoreItem {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 80px;
      p {
        margin: 0;
        &:first-child {
          color: #000;
          font-size: 15px;
          font-weight: 400;
        }
        &:last-child {
          margin-top: 6px;
          color: #999;
          font-size: 13px;
        }
      }
    }
  }
  .list {
    flex: 1;
    transform: translateY(-38px);
    li {
      position: relative;
      margin-left: 18px;
      margin-right: 18px;
    }
    .detailedList {
      box-sizing: border-box;
      padding: 0 18px;
      background-color: #fff;
      box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
      &.active {
        border: 2px dashed #4878ff;
      }
      .detailedItem {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 84px;
        border-bottom: 1px solid #e6e6e6;
        &:last-child {
          border: none;
        }
        .detail {
          display: flex;
          align-items: center;
          .icon {
            width: 40px;
            height: 40px;
            margin-right: 16px;
          }
          .name {
            color: #000;
            font-size: 15px;
            font-weight: 500;
          }
        }
        i {
          font-size: 20px;
          color: #ccc;
        }
      }
    }
  }
}
</style>
